import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  MonthlyBar,
  SidebarStyle,
  ColumnStyle,
  ColumnOneStyle,
  SoldTextStyle,
  RowStyle,
  Separator,
  MonthlyContainer,
  MonthTextContainer,
  MonthText,
  MonthlyDetailsContainer,
  MissedText,
  ValueStyle
} from '../../../../atoms/dashboard/quarterlyDetails.styles';
import { GreenColorStyle, OrangeColorStyle } from '../../../../atoms/sidebar/sidebar.styles';
import { MotifButton } from '@ey-xd/motif-react';
import { CurrentPill, FuturePillDashboard } from '../../../../../constants/pursuitLeaderConstants';
import { useRecoilValue } from 'recoil';
import { Recoil_Quarter_State, System_Date_Time_State } from '../../../../../recoil/recoil';
import {
  formatNumberWithKAndM,
  getAccuracy,
  uppercaseFirstLetter,
} from '../../../../../util/commonUtil';
import { isMobile } from 'react-device-detect';
import {
  BUTTON_TITLE,
  MONTH_QUARTER_STATUS,
  PERIOD,
  QUARTERLY_DETAILS,
} from '../../../../../constants/commonConstants';

const MonthlyDetails = props => {
  let { quarterData, email, account } = props;
  const navigate = useNavigate();
  let monthDataInfo = quarterData.data['months'];
  let quarterDataInfo = quarterData.data['quarterlyCalculation'];
  let quarterInfo = useRecoilValue(Recoil_Quarter_State);
  const systemDateTime = useRecoilValue(System_Date_Time_State);

  let TodaysDate = new Date(systemDateTime);

  const buttonStyle = {
    width: 75,
    height: 26,
    fontWeight: 400,
    padding: '20px 0px',
  };

  return (
    <>
      {!!monthDataInfo && !!quarterDataInfo && (
        <MonthlyBar>
          {monthDataInfo.map((item, index) => (
            <MonthlyContainer key={index}>
              <SidebarStyle>
                <ColumnOneStyle>
                  <MonthTextContainer>
                    <MonthText>{uppercaseFirstLetter(item.month).slice(0, 3)}</MonthText>
                    {!!quarterInfo &&
                      uppercaseFirstLetter(item.month).slice(0, 3) == quarterInfo.month &&
                      item?.calculation?.period !== PERIOD.FUTURE &&
                      item?.calculation?.actual_period == PERIOD.CURRENT && <CurrentPill />}

                    {item?.calculation?.period === PERIOD.FUTURE && <FuturePillDashboard />}
                  </MonthTextContainer>
                </ColumnOneStyle>
                {isMobile && <div />}
                {!isMobile && <MonthWiseDetails item={item} quarterInfo={quarterInfo} />}

                <ColumnStyle>
                  {uppercaseFirstLetter(item.month).slice(0, 3) === quarterInfo.month &&
                  item?.calculation?.period !== PERIOD.FUTURE &&
                  item?.calculation?.actual_period == PERIOD.CURRENT &&
                  new Date(TodaysDate.getFullYear(), TodaysDate.getMonth(), TodaysDate.getDate()) <=
                    new Date(quarterInfo.persona_closedate) ? (
                    <MotifButton
                      style={buttonStyle}
                      onClick={() => {
                        navigate('/forecast');
                      }}
                    >
                      {BUTTON_TITLE.FORECAST}
                    </MotifButton>
                  ) : uppercaseFirstLetter(item.month).slice(0, 3) === quarterInfo.month &&
                    item?.calculation?.period !== PERIOD.FUTURE &&
                    TodaysDate > new Date(quarterInfo.persona_closedate) ? (
                    <MotifButton
                      variant="secondary"
                      style={buttonStyle}
                      onClick={() => {
                        navigate('/forecast/past', {
                          state: {
                            year: quarterData.yearText,
                            quarter: quarterData.quarterText,
                            month: item.month,
                            email: email,
                            account: account,
                            forecast_type: 'month',
                          },
                        });
                      }}
                      aria-label={`View details of month ${item.month}`}
                    >
                      <span aria-hidden="true">{BUTTON_TITLE.VIEW}</span>
                    </MotifButton>
                  ) : item?.calculation?.tag === MONTH_QUARTER_STATUS.NOT_APPLICABLE ? (
                    <MotifButton variant="secondary" style={buttonStyle} disabled>
                      <span aria-hidden="true">{BUTTON_TITLE.VIEW}</span>
                    </MotifButton>
                  ) : item?.calculation?.period === PERIOD.PAST &&
                    uppercaseFirstLetter(item.month).slice(0, 3) !== quarterInfo.month &&
                    item?.calculation?.period !== PERIOD.FUTURE ? (
                    <MotifButton
                      variant="secondary"
                      style={buttonStyle}
                      onClick={() => {
                        navigate('/forecast/past', {
                          state: {
                            year: quarterData.yearText,
                            quarter: quarterData.quarterText,
                            month: item.month,
                            email: email,
                            account: account,
                            forecast_type: 'month',
                          },
                        });
                      }}
                      aria-label={`View details of month ${item.month}`}
                    >
                      <span aria-hidden="true">{BUTTON_TITLE.VIEW}</span>
                    </MotifButton>
                  ) : item?.calculation?.period === PERIOD.FUTURE &&
                    uppercaseFirstLetter(item.month).slice(0, 3) !==
                      quarterInfo.month ? null : null}
                </ColumnStyle>
              </SidebarStyle>

              {isMobile && <MonthWiseDetails item={item} quarterInfo={quarterInfo} />}

              {!!monthDataInfo && monthDataInfo.length - 2 >= index && <Separator />}
            </MonthlyContainer>
          ))}
        </MonthlyBar>
      )}
    </>
  );
};

const MonthWiseDetails = data => {
  let item = data.item;
  let quarterInfo = data.quarterInfo;

  const getValue = value => {
    if (item?.calculation?.tag === MONTH_QUARTER_STATUS.NOT_APPLICABLE) {
      return QUARTERLY_DETAILS.NOT_APPLICABLE;
    } else {
      return formatNumberWithKAndM(value) || 0;
    }
  };

  return (
    <MonthlyDetailsContainer>
      <ColumnStyle>
        <RowStyle>
          <SoldTextStyle style={{ paddingRight: 5 }}>{QUARTERLY_DETAILS.WON}</SoldTextStyle>
          <GreenColorStyle />
        </RowStyle>
        <ValueStyle>
          {item?.calculation?.period == PERIOD.FUTURE && <span>{QUARTERLY_DETAILS.TBD}</span>}
          {item?.calculation?.period != PERIOD.FUTURE && (
            <span>{getValue(item?.calculation?.sold)}</span>
          )}
        </ValueStyle>
      </ColumnStyle>

      <ColumnStyle>
        <RowStyle>
          <SoldTextStyle>
            {!!quarterInfo && item?.calculation?.actual_period === PERIOD.PAST ? (
              <span>{QUARTERLY_DETAILS.WON_OPPS}</span>
            ) : item?.calculation?.actual_period === PERIOD.FUTURE ? (
              <span>{QUARTERLY_DETAILS.PROJECTED_OPPS}</span>
            ) : (
              <span>{QUARTERLY_DETAILS.COMMIT_OPPS}</span>
            )}
          </SoldTextStyle>
        </RowStyle>
        <ValueStyle>
          <span>
            {' '}
            {item?.calculation?.period == PERIOD.FUTURE ||
            uppercaseFirstLetter(item.month).slice(0, 3) == quarterInfo.month
              ? getValue(item?.calculation?.count_commit)
              : getValue(item?.calculation?.count_sold)}
          </span>
        </ValueStyle>
      </ColumnStyle>

      <ColumnStyle>
        <RowStyle>
          <SoldTextStyle>
            {!!quarterInfo && item?.calculation?.actual_period === PERIOD.PAST ? (
              <span>{QUARTERLY_DETAILS.FORECAST}</span>
            ) : item?.calculation?.actual_period === PERIOD.FUTURE ? (
              <span>{QUARTERLY_DETAILS.PROJECTED}</span>
            ) : (
              <span>{QUARTERLY_DETAILS.COMMIT}</span>
            )}
          </SoldTextStyle>
        </RowStyle>
        <ValueStyle>
          <span>
            {getValue(item?.calculation?.commit)}{' '}
            {item?.calculation?.tag == MONTH_QUARTER_STATUS.MISSED && (
              <MissedText> ({QUARTERLY_DETAILS.MISSED})</MissedText>
            )}
          </span>
        </ValueStyle>
      </ColumnStyle>

      <ColumnStyle
        style={{
          borderRight: isMobile ? '0px solid #E7E7EA' : '1px solid #E7E7EA',
        }}
      >
        <RowStyle>
          <SoldTextStyle>{QUARTERLY_DETAILS.ACCURACY}</SoldTextStyle>
        </RowStyle>
        <ValueStyle>
          {item?.calculation?.period == PERIOD.FUTURE && <span>{QUARTERLY_DETAILS.TBD}</span>}
          {item?.calculation?.period != PERIOD.FUTURE && (
            <span>
              {item?.calculation?.tag === MONTH_QUARTER_STATUS.NOT_APPLICABLE
                ? QUARTERLY_DETAILS.NOT_APPLICABLE
                : (getAccuracy(item?.calculation?.sold, item?.calculation?.commit) || 0) + '%'}
            </span>
          )}
        </ValueStyle>
      </ColumnStyle>
    </MonthlyDetailsContainer>
  );
};

export default MonthlyDetails;
